function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import axios from 'axios';
export var createDriver = function createDriver(axiosInstance) {
  return function (requestConfig) {
    var abortSource = axios.CancelToken.source();
    var responsePromise = axiosInstance(_extends({
      cancelToken: abortSource.token
    }, requestConfig)).then(function (response) {
      return {
        data: response.data,
        status: response.status,
        headers: response.headers
      };
    })["catch"](function (error) {
      if (axios.isCancel(error)) {
        throw 'REQUEST_ABORTED';
      }

      throw error;
    });

    responsePromise.cancel = function () {
      return abortSource.cancel();
    };

    return responsePromise;
  };
};